import { get } from 'lodash';
import { retrieveDataMapper, retrieveObjectMapper } from '../..';

export const transformMeUserDetails = ({
  resp,
  roleRelations,
  roles,
  roleTemplates,
  accessControls,
  school,
  centres,
  programs,
  levels,
  classes,
  childClasses,
  childClosestLevels,
  parent,
  childRelations,
  children,
  enrolmentStatuses,
  regParents,
  regChildParents = [],
  regChildren = {},
}) => {
  return {
    success: true,
    data: {
      me: {
        ...retrieveObjectMapper(resp, [
          'ID:id',
          'firstname',
          'lastname',
          'email',
          'linkpassUID:linkpass_uid',
          'birthdate',
          'image_key',
          'imageKeyPresignedURL:image_key_presigned_url',
          'gender',
          'home_phone',
          'mobile_phone',
          'mobile_phone_country_code',
          'isHQStaff:is_hq_staff',
          'hasCentreScopeAccess:is_centre_scope',
          'hasClassScopeAccess:is_class_scope',
        ]),
        userRoleRelations: {
          data: get(roleRelations, 'data', [])?.map(roleRelation => ({
            ID: roleRelation?.id,
            role: {
              ...retrieveDataMapper(roles, roleRelation.fk_role, [
                'ID:id',
                'label',
                'name',
                'is_staff',
              ]),
              roleTemplates: {
                data: (get(roleTemplates, roleRelation.fk_role) || []).map(
                  template =>
                    retrieveObjectMapper(template, [
                      'fk_module_category',
                      'access',
                    ])
                ),
              },
            },
          })),
        },
        userAccessControls: {
          data: get(accessControls, 'data', [])?.map(accessControl => ({
            school: retrieveObjectMapper(school, ['ID:id', 'name']),
            centre: (() => {
              const ctre = retrieveDataMapper(
                centres?.data,
                accessControl.fk_centre,
                ['ID:id', 'label']
              );
              if (!ctre) {
                return null;
              }
              return {
                ...ctre,
                school: retrieveObjectMapper(school, ['ID:id', 'name']),
              };
            })(),
          })),
        },
        parent: retrieveObjectMapper(parent, [
          'ID:id',
          'monthly_income',
          'workplace_staff',
        ]),
        registrationParent: (() => {
          const regParent = retrieveDataMapper(
            regParents,
            get(resp, 'id'),
            ['fk_parent'],
            'fk_user'
          );
          if (!regParent) return null;
          return {
            ...regParent,
            registrationChildParents: regChildParents
              ?.filter(
                regChildParent =>
                  regChildParent?.fk_registration_parent === regParent?.fkParent
              )
              ?.map(regChildParent => ({
                registrationChild: retrieveDataMapper(
                  regChildren,
                  regChildParent?.fk_registration_child,
                  [
                    'ID:id',
                    'fk_child',
                    'firstname',
                    'lastname',
                    'race',
                    'nationality',
                    'date_of_birth',
                    'birth_certificate',
                    'household_income_range',
                  ]
                ),
              })),
          };
        })(),
        childRelations: {
          data: childRelations?.map(childRelation => ({
            child: {
              ...retrieveDataMapper(children, childRelation?.fk_child, [
                'ID:id',
                'firstname',
                'lastname',
                'race',
                'nationality',
                'image_key',
                'imageKeyPresignedURL:image_key_presigned_url',
                'date_of_birth',
                'birth_certificate',
                'household_income_range',
                'first_enrolment_date',
              ]),
              childClasses: {
                data: childClasses
                  ?.filter(f => f.fk_child === childRelation?.fk_child)
                  ?.map(d => ({
                    ...retrieveObjectMapper(d, ['fk_class', 'from', 'to']),
                    program: retrieveDataMapper(programs, d?.fk_program, [
                      'from',
                      'to',
                      'label',
                    ]),
                    class: retrieveDataMapper(classes, d?.fk_class, [
                      'ID:id',
                      'fk_centre',
                      'fk_level',
                      'label',
                    ]),
                  })),
              },
              enrolmentStatus: retrieveDataMapper(
                enrolmentStatuses,
                childRelation?.fk_child,
                ['status', 'label']
              ),
              closestLevel: (() => {
                const level = retrieveDataMapper(
                  childClosestLevels,
                  childRelation?.fk_child,
                  ['ID:id', 'fk_centre', 'fk_program', 'fk_level'],
                  'fk_child'
                );
                return {
                  ...level,
                  centre: retrieveDataMapper(centres?.data, level?.fkCentre, [
                    'ID:id',
                    'label',
                  ]),
                  level: retrieveDataMapper(levels, level?.fkLevel, [
                    'ID:id',
                    'label',
                  ]),
                  program: retrieveDataMapper(programs, level?.fkProgram, [
                    'ID:id',
                    'type',
                    'label',
                  ]),
                };
              })(),
            },
          })),
        },
      },
    },
  };
};

export default {
  transformMeUserDetails,
};
